import Reveal from "@/components/Reveal";
import ThemeTag from "@/components/ThemeTag";

const ITEMS = [
  {
    letter: "A",
    title: "Solve real organisational problems",
    body: "Work through practical case studies involving service failures, operational inefficiencies, team conflict and organisational change.",
  },
  {
    letter: "B",
    title: "Make better strategic decisions",
    body: "Learn to evaluate competing options, weigh risks, prioritise resources and justify decisions using evidence.",
  },
  {
    letter: "C",
    title: "Lead through collaboration",
    body: "Practise stakeholder engagement, conflict resolution, accountability and team-based problem-solving.",
  },
  {
    letter: "D",
    title: "Turn plans into measurable impact",
    body: "Develop action plans with clear responsibilities, deadlines, performance indicators and review mechanisms.",
  },
];

export default function ParticipantExperience() {
  return (
    <section className="dark px-section">
      <img
        className="dark-texture"
        src="https://images.unsplash.com/photo-1742870668961-b3a1721ab483?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHwyfHxkYXJRJTIwZ3JlZW4lMjBtYXJibGUlMjB0ZXh0dXJlJTIwYWJzdHJhY3QlMjBiYWNrZ3JvdW5kJTIwbHV4dXJ5fGVufDB8fHx8MTc5MjUyODIzNnww&ixlib=rb-4.1.0&q=85"
        alt=""
        aria-hidden="true"
        loading="lazy"
      />
      <div className="wrap">
        <Reveal className="head">
          <div className="kicker">The participant experience</div>
          <h2 className="title">Four muscles every delegate builds.</h2>
          <ThemeTag light />
        </Reveal>
        <div className="px-grid">
          {ITEMS.map((item, i) => (
            <Reveal key={item.letter} delay={i * 0.09} className="px-card" data-testid="participant-experience-card">
              <span className="px-letter">{item.letter}</span>
              <h3>{item.title}</h3>
              <p>{item.body}</p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
